import { isRetina } from '@/scripts/utils';

export default {
  images: {
    LIGHT_CIRCLE: {
      url: '/assets/textures/light-circle.png',
    },
    BUSH_1: {
      url: `/assets/textures${isRetina() ? '/2x' : ''}/bush_1.png`,
    },
    BUSH_2: {
      url: `/assets/textures${isRetina() ? '/2x' : ''}/bush_2.png`,
    },
    BUSH_3: {
      url: `/assets/textures${isRetina() ? '/2x' : ''}/bush_3.png`,
    },
    BUSH_4: {
      url: `/assets/textures${isRetina() ? '/2x' : ''}/bush_4.png`,
    },
    BUSH_BOTTOM_LEFT: {
      url: '/assets/textures/bush-bottom_left.png',
    },
    BUSH_BOTTOM_RIGHT: {
      url: '/assets/textures/bush-bottom_right.png',
    },
    PLAYER_LIGHT_BOTTOM: {
      url: '/assets/textures/player-light_bottom.png',
    },
    PLAYER_LIGHT_UPPER: {
      url: '/assets/textures/player-light_upper.png',
    },
    PLAYER_BOTTOM: {
      url: '/assets/textures/player-bottom.png',
    },
    PLAIN_BLUE: {
      url: '/assets/textures/blue.png',
    },
    PLAIN_RED: {
      url: '/assets/textures/red.png',
    },
    PLAIN_YELLOW: {
      url: '/assets/textures/yellow.png',
    },
    PLAIN_GREEN: {
      url: '/assets/textures/green.png',
    },
    PLAIN_PURPLE: {
      url: '/assets/textures/purple.png',
    },
    PLAIN_ORANGE: {
      url: '/assets/textures/orange.png',
    },
    FLOOR: {
      url: '/assets/textures/floor.png',
    },
    INTRO_BACKGROUND: {
      url: '/assets/textures/intro-background.jpg',
    },
    INTRO_BUSHES_LEFT_FORE: {
      url: '/assets/textures/intro-bushes-left_fore.png',
    },
    INTRO_BUSHES_LEFT_BACK: {
      url: '/assets/textures/intro-bushes-left_back.png',
    },
    INTRO_BUSHES_RIGHT_FORE: {
      url: '/assets/textures/intro-bushes-right_fore.png',
    },
    INTRO_BUSHES_RIGHT_BACK: {
      url: '/assets/textures/intro-bushes-right_back.png',
    },
    COURTAIN_BUSH_LEFT: {
      url: '/assets/textures/courtain-bush_left.png',
    },
    COURTAIN_BUSH_RIGHT: {
      url: '/assets/textures/courtain-bush_right.png',
    },
    FLOWERS: {
      url: `/assets/pack${isRetina() ? '/2x' : ''}/flowers.json`,
    },
    POWERUPS: {
      url: `/assets/pack${isRetina() ? '/2x' : ''}/powerups.json`,
    },
    BACKGROUND: {
      url: `/assets/pack${isRetina() ? '/2x' : ''}/background.json`,
    },
  },
  video: {
    PLAYER_FLORENCE: {
      url: '/assets/pack/player_florence.json',
    },
    PLAYER_ARMS_WALK_FLORENCE: {
      url: '/assets/pack/walking_florence.json',
    },
    PLAYER_ARMS_SHOOT_FLORENCE: {
      url: '/assets/pack/shoot_florence.json',
    },
    PLAYER_JODIE: {
      url: '/assets/pack/player_jodie.json',
    },
    PLAYER_ARMS_WALK_JODIE: {
      url: '/assets/pack/walking_jodie.json',
    },
    PLAYER_ARMS_SHOOT_JODIE: {
      url: '/assets/pack/shoot_jodie.json',
    },
    PLAYER_ANJELICA: {
      url: '/assets/pack/player_anjelica.json',
    },
    PLAYER_ARMS_WALK_ANJELICA: {
      url: '/assets/pack/walking_anjelica.json',
    },
    PLAYER_ARMS_SHOOT_ANJELICA: {
      url: '/assets/pack/shoot_anjelica.json',
    },
    PLAYER_SUSIE: {
      url: '/assets/pack/player_susie.json',
    },
    PLAYER_ARMS_WALK_SUSIE: {
      url: '/assets/pack/walking_susie.json',
    },
    PLAYER_ARMS_SHOOT_SUSIE: {
      url: '/assets/pack/shoot_susie.json',
    },
    BRANCHES_LEFT_1: {
      url: '/assets/pack/branches-left_1.json',
    },
    BRANCHES_RIGHT_1: {
      url: '/assets/pack/branches-right_1.json',
    },
    BRANCHES_LEFT_2: {
      url: '/assets/pack/branches-left_2.json',
    },
    BRANCHES_RIGHT_2: {
      url: '/assets/pack/branches-right_2.json',
    },
    BRANCHES_LEFT_3: {
      url: '/assets/pack/branches-left_3.json',
    },
    BRANCHES_RIGHT_3: {
      url: '/assets/pack/branches-right_3.json',
    },
    LIGHT_RAY: {
      url: '/assets/pack/light-ray.json',
    },
    LIGHT_DISC: {
      url: '/assets/pack/light-disc.json',
    },
    LIGHT_RAY_WIDE: {
      url: '/assets/pack/light-ray_wide.json',
    },
    LIGHT_DISC_WIDE: {
      url: '/assets/pack/light-disc_wide.json',
    },
    LIGHT_RAY_FAR: {
      url: '/assets/pack/light-ray_far.json',
    },
    LIGHT_DISC_FAR: {
      url: '/assets/pack/light-disc_far.json',
    },
    LIGHT_PARTICLES: {
      url: '/assets/pack/light-particles.json',
    },
    BLOW_ALL_1: {
      url: '/assets/pack/blow-all_1.json',
    },
    BLOW_ALL_2: {
      url: '/assets/pack/blow-all_2.json',
    },
    BLOW_ALL_3: {
      url: '/assets/pack/blow-all_3.json',
    },
    POWERUP_POWER: {
      url: '/assets/pack/powerup_power.json',
    },
    POWERUP_EFFECT_1: {
      url: '/assets/pack/powerup-effect_1.json',
    },
    POWERUP_EFFECT_2: {
      url: '/assets/pack/powerup-effect_2.json',
    },
  },
};
